import type { ReactNode } from 'react';

interface PageIntroProps {
  eyebrow: string;
  title: string;
  description: string;
  children?: ReactNode;
}

export default function PageIntro({
  eyebrow,
  title,
  description,
  children,
}: PageIntroProps) {
  return (
    <section className="page-hero">
      <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_18rem] lg:items-end">
        <div className="space-y-5">
          <span className="eyebrow">{eyebrow}</span>
          <h1 className="section-title max-w-3xl">{title}</h1>
          <p className="section-copy max-w-3xl">{description}</p>
        </div>
        {children ? <div className="space-y-4">{children}</div> : null}
      </div>
    </section>
  );
}
